import {useState} from "react"

export function SignalQuestion ({auth, num_quest}) {

	const [signalQuestion, setSignalQuestion] = useState(false)
	const [envoiQuestion, setEnvoiQuestion] = useState(false)

	const handleClick = (e) => {
		fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
	    method: 'POST',
	    body: JSON.stringify({...auth, action:'signalQuestionProf', num_question:num_quest})
	  })
	  .then(response => response.json())
	  .then(datas => {
	  	//console.log('datas : ' + datas)
	  })
	  .catch(err => {
	  	alert('Erreur de connexion, les données n\'ont pas pu être récupérées.')
	  	console.log('Erreur ==> ' + err)
	  })

    setEnvoiQuestion(true)
  }

  return (
    <div className={envoiQuestion ? ' fadeout3' : ''}>
    	<div align='center'>
	    	<div style={{cursor:'pointer'}} onClick={()=>setSignalQuestion(!signalQuestion)}>❓</div>
	    	{signalQuestion && <div className={'alert danger'+(envoiQuestion ? ' fadeout3' : '')}>
		    	Je n'ai pas compris la réponse à la question n°{num_quest.split('_')[1]}. <br/>
		    	Je le signale à mon professeur en cliquant ici : <br/> 
		    	{!envoiQuestion && <input style={{cursor:'pointer', color:'#314519', padding:'5px 10px'}} type='button' value='Signaler' onClick={handleClick} />}

		    	{envoiQuestion && <div style={{color:'#314519', padding:'20px 10px'}}>Votre demande d'explications a bien été envoyée à votre professeur.</div>}
	    	</div>}
    	</div>
    </div>
  );
}